<div class="container mt-3">
  <div class="card shadow-mm">
    <div class="card-header bg-primary text-white">
      <h4 class="mb-0">INFORMATION TECHNOLOGY FACILITY REQUEST FORM</h4>
    </div>
    <div class="card-body">
      
        <div class="row g-3">
          <div class="col-md-6">
            <label for="IR_AccountType" class="form-label">Source Type</label>
            <select
              id="IR_AccountType"
              class="form-select form-select-mm"
              [(ngModel)]="add.IR_AccountType"
              name="IR_AccountType"
              required>
              <option value="IT Facility">IT Facility</option>
              <option value="BC 365">BC 365</option>
            </select>
          </div>

          <!-- Employee ID -->
          <div class="col-md-6">
            <label for="IR_EmployeeId" class="form-label">Employee ID</label>
            <input
              id="IR_EmployeeId"
              type="text"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_EmployeeId"
              name="IR_EmployeeId"
            (keydown.enter)="Onempselect(add.IR_EmployeeId)"
              required />
            <!-- <select
              id="IR_EmployeeId"
              class="form-select form-select-mm"
              [(ngModel)]="add.IR_EmployeeId"
              name="IR_EmployeeId"
              (change)="Onempselect(add.IR_EmployeeId)"
              required>
              <option *ngFor="let emp of appservice.ITfacility_empid" [value]="emp.OD_EmployeeID">
                {{ emp.OD_EmployeeID }}
              </option>
            </select> -->
          </div>

          <!-- Full Name -->
          <div class="col-md-6">
            <label for="IR_Fullname" class="form-label">Full Name</label>
            <input
              id="IR_Fullname"
              type="text"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_Fullname"
              name="IR_Fullname"
              required />
          </div>

          <!-- Active Directory Username -->
          <div class="col-md-6">
            <label for="IR_ADUserName" class="form-label">Active Directory Username</label>
            <input
              id="IR_ADUserName"
              type="text"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_ADUserName"
              name="IR_ADUserName"
              required />
          </div>

          <!-- Contact MailID -->
          <div class="col-md-6">
            <label for="IR_ADMailId" class="form-label">Mail ID</label>
            <input
              id="IR_ADMailId"
              type="email"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_ADMailId"
              name="IR_ADMailId"
              required />
          </div>

          <!-- Designation -->
          <div class="col-md-6">
            <label for="IR_Designation" class="form-label">Designation</label>
            <input
              id="IR_Designation"
              type="text"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_Designation"
              name="IR_Designation" />
          </div>

          <!-- Grade -->
          <div class="col-md-6">
            <label for="IR_Grade" class="form-label">Location</label>
            <input
              id="IR_Grade"
              type="text"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_Grade"
              name="IR_Grade" />
          </div>

          <!-- Department -->
          <div class="col-md-6">
            <label for="IR_Department" class="form-label">Department</label>
            <input
              id="IR_Department"
              type="text"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_Department"
              name="IR_Department" />
          </div>

          <!-- Reporting To -->
          <div class="col-md-6">
            <label for="IR_ReportingId" class="form-label">Reporting To</label>
            <input
              id="IR_ReportingId"
              type="text"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_ReportingId"
              name="IR_ReportingId" />
          </div>

          <div class="col-md-6">
            <label for="IR_ReporterName" class="form-label">Reporter Name</label>
            <input
              id="IR_ReporterName"
              type="text"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_ReporterName"
              name="IR_ReporterName" />
          </div>

          <div class="col-md-6">
            <label for="IR_ReporterDesignation" class="form-label">Reporter Designation</label>
            <input
              id="IR_ReporterDesignation"
              type="text"
              class="form-control form-control-mm"
              [(ngModel)]="add.IR_ReporterDesignation"
              name="IR_ReporterDesignation" />
          </div>

          <!-- Reporter MailID -->
          <div class="col-md-6">
            <label for="reporterMail" class="form-label">Reporter Mail ID</label>
            <input
              id="reporterMail"
              type="email"
              class="form-control form-control-mm"
              [(ngModel)]="add.reporterMail"
              name="reporterMail" />
          </div>

          <div class="col-md-6">
            <label for="Dateofjoin" class="form-label">Date of Joining</label>
            <input id="Dateofjoin" type="date" class="form-control form-control-mm" [(ngModel)]="add.Dateofjoin" name="Dateofjoin">
          </div>

          <div class="col-md-6">
            <label for="Requestdate" class="form-label">Request Date</label>
            <input id="Requestdate" type="date" class="form-control form-control-mm" [(ngModel)]="add.Requestdate" name="Requestdate">
          </div>

          <!-- IT Facility Section -->
          <div *ngIf="add.IR_AccountType !== 'BC 365'" class="col-12">
            <div class="row g-3">
              <!-- Asset Type -->
              <div class="col-md-6">
                <label for="IR_AssertType" class="form-label">Asset Type</label>
                <select
                  id="IR_AssertType"
                  class="form-select form-select-mm"
                  [(ngModel)]="add.IR_AssertType"
                  name="IR_AssertType">
                  <option value="">-- Select --</option>
                  <option value="Laptop">Laptop</option>
                  <option value="Desktop">Desktop</option>
                </select>
              </div>
              
              <!-- NAC Drive Access -->
              <div class="col-md-6">
                <label for="IR_NacDriver_Access" class="form-label">NAS Drive Access</label>
                <select id="IR_NacDriver_Access" class="form-select form-select-mm" [(ngModel)]="add.IR_NacDriver_Access" name="IR_NacDriver_Access">
                  <option value="">-- Select --</option>
                  <option value="Applicable">Applicable</option>
                  <option value="Not Applicable">Not Applicable</option>
                </select>
              </div>

              <!-- Dongle & Sim Card -->
              <div class="col-md-6">
                <label for="IR_Dongle_SimCard" class="form-label">Dongle & Sim Card</label>
                <select id="IR_Dongle_SimCard" class="form-select form-select-mm" [(ngModel)]="add.IR_Dongle_SimCard" name="IR_Dongle_SimCard">
                  <option value="">-- Select --</option>
                  <option value="Applicable">Applicable</option>
                  <option value="Not Applicable">Not Applicable</option>
                </select>
              </div>

              <div *ngIf="add.IR_Dongle_SimCard=='Applicable'" class="col-md-6">
                <label for="IR_SimNofordongle" class="form-label">Sim No|Sim Brand</label>
                <input id="IR_SimNofordongle" type="text" class="form-control form-control-mm" [(ngModel)]="add.IR_SimNofordongle" name="IR_SimNofordongle">
              </div>

              <!-- Mobile & Sim Card -->
              <div class="col-md-6">
                <label for="IR_Mobilesim" class="form-label">Mobile & Sim Card</label>
                <select id="IR_Mobilesim" class="form-select form-select-mm" [(ngModel)]="add.IR_Mobilesim" name="IR_Mobilesim">
                  <option value="">-- Select --</option>
                  <option value="Applicable">Applicable</option>
                  <option value="Not Applicable">Not Applicable</option>
                </select>
              </div>

              <div *ngIf="add.IR_Mobilesim=='Applicable'" class="col-md-6">
                <label for="IR_SimNoformobile" class="form-label">Sim No|Sim Brand</label>
                <input id="IR_SimNoformobile" type="text" class="form-control form-control-mm" [(ngModel)]="add.IR_SimNoformobile" name="IR_SimNoformobile">
              </div>

              <!-- Biometric Access Card -->
              <div class="col-md-6">
                <label for="IR_Biometric_card" class="form-label">Biometric Access Card</label>
                <select id="IR_Biometric_card" class="form-select form-select-mm" [(ngModel)]="add.IR_Biometric_card" name="IR_Biometric_card">
                  <option value="">-- Select --</option>
                  <option value="Applicable">Applicable</option>
                  <option value="Not Applicable">Not Applicable</option>
                </select>
              </div>

              <!-- Door Access -->
              <div class="col-md-6">
                <label for="IR_Other" class="form-label">Other</label>
                <textarea
                  id="IR_Other" 
                  rows="3"
                  class="form-control form-control-mm"
                  [(ngModel)]="add.IR_Other"
                  name="IR_Other"></textarea>
              </div>
            </div>
          </div>

          <!-- BC 365 Section -->
          <div *ngIf="add.IR_AccountType === 'BC 365'" class="col-12">
            <div class="row g-3">
              <div class="col-md-6">
                <label for="MR_AssertType" class="form-label">Account Type</label>
                <select
                  id="MR_AssertType"
                  class="form-select form-select-mm"
                  [(ngModel)]="add.MD_AssertType"
                  name="MR_AssertType">
                  <option value="">-- Select --</option>
                  <option value="Creation">Creation</option>
                  <option value="Modification">Modification</option>
                  <option value="Revocation">Revocation</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="Companyname" class="form-label">Company Name</label>
                <input
                  id="Companyname"
                  type="text"
                  class="form-control form-control-mm"
                  [(ngModel)]="add.Companyname"
                  name="Companyname" />
              </div>

              <div class="col-md-6">
                <label for="MD_UserId" class="form-label">User ID</label>
                <input
                  id="MD_UserId"
                  type="text"
                  class="form-control form-control-mm"
                  [(ngModel)]="add.MD_UserId"
                  name="MD_UserId" />
              </div>

              <div class="col-md-6">
                <label for="MD_RoleCenter" class="form-label">Role Center</label>
                <select
                  id="MD_RoleCenter"
                  class="form-select form-select-mm"
                  [(ngModel)]="add.MD_RoleCenter"
                  name="MD_RoleCenter">
                  <option value="Bookkeeper">Bookkeeper</option>
                  <option value="Business Manager">Business Manager</option>
                  <option value="Finance User">Finance User</option>
                  <option value="Purchase role center">Purchase role center</option>
                  <option value="Production role center">Production role center</option>
                  <option value="Sales & Marketing">Sales & Marketing</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="MD_Previlage_Access" class="form-label">Privileged Access</label>
                <select
                  id="MD_Previlage_Access"
                  class="form-select form-select-mm"
                  [(ngModel)]="add.MD_Previlage_Access"
                  name="MD_Previlage_Access">
                  <option value="Applicable">Applicable</option>
                  <option value="Not Applicable">Not Applicable</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="MD_Approval_Access" class="form-label">Approval Access</label>
                <select
                  id="MD_Approval_Access"
                  class="form-select form-select-mm"
                  [(ngModel)]="add.MD_Approval_Access"
                  name="MD_Approval_Access">
                  <option value="Applicable">Applicable</option>
                  <option value="Not Applicable">Not Applicable</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="MD_ObjectId" class="form-label">Object Id</label>
                <input
                  id="MD_ObjectId"
                  type="text"
                  class="form-control form-control-mm"
                  [(ngModel)]="add.MD_ObjectId"
                  name="MD_ObjectId" />
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="col-12">
            <div class="d-grid mt-4">
              <button type="submit" class="btn btn-primary btn-lg" (click)="onSubmit()">Submit</button>
            </div>
          </div>
        </div>
     
    </div>
  </div>
</div>